import { render } from "./TwitterComponent.vue?vue&type=template&id=374f0fce&scoped=true"
import script from "./TwitterComponent.vue?vue&type=script&lang=js"
export * from "./TwitterComponent.vue?vue&type=script&lang=js"

import "./TwitterComponent.vue?vue&type=style&index=0&id=374f0fce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-374f0fce"]])

export default __exports__